function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.396 11.493v1.178a1.606 1.606 0 001.291 1.572v-3.062h-.979a.312.312 0 00-.312.312zM11.101 10.375a1.1 1.1 0 10-2.202 0v.18H11.1v-.18z",
  fill: "#28293D"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.875 6.003a.313.313 0 01-.313-.313V1.25H4.248a1.564 1.564 0 00-1.563 1.563v14.374a1.564 1.564 0 001.563 1.563h11.504a1.565 1.565 0 001.563-1.563V6.004h-4.44zm-8.057-2.5h5.245a.313.313 0 110 .625H4.816a.312.312 0 110-.626zM4.505 5.69a.313.313 0 01.313-.313h5.245a.313.313 0 110 .626H4.816a.312.312 0 01-.312-.313zm9.17 5.49a.312.312 0 01-.246.306l-1.2.259v.613h.884a.313.313 0 110 .625h-.908a2.208 2.208 0 01-.205.665h1.05a.313.313 0 01.303.235l.313 1.204a.31.31 0 01-.222.392.312.312 0 01-.383-.236l-.252-.97h-1.264a2.219 2.219 0 01-3.09 0H7.191l-.252.97a.312.312 0 11-.605-.156l.313-1.204a.312.312 0 01.302-.235H8a2.205 2.205 0 01-.205-.665h-.908a.312.312 0 110-.625h.884v-.613l-1.2-.26a.312.312 0 01-.247-.305V9.743a.313.313 0 01.625 0v1.187l.899.194a.937.937 0 01.426-.455v-.294a1.726 1.726 0 113.452 0v.291c.19.099.34.26.426.456l.899-.194V9.74a.313.313 0 01.625 0v1.44z",
  fill: "#28293D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.187 1.434v3.944h3.945l-3.945-3.944zM11.292 11.18h-.98v3.063a1.606 1.606 0 001.292-1.572v-1.178a.312.312 0 00-.312-.312z",
  fill: "#28293D"
});

function SvgFileBug(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}

export default SvgFileBug;